/**
 * Legacy PermissionsApiService module — preserved as an empty AngularJS module
 * so existing dependencies (`acme.common.service.permissionsApi`) keep resolving.
 *
 * The actual PermissionsApiService is now exposed through the Angular 18
 * ApiService facade. Implementation:
 *   apps/b2b-frontend/app/core/api/permissions/permissions-api.service.ts
 */
angular.module("acme.common.service.permissionsApi", [
  "acme.common.factory.QueryStringBuilder",
]);
